import { render, staticRenderFns } from "./InstantBuy.vue?vue&type=template&id=ce0a9202&scoped=true&"
import script from "./InstantBuy.vue?vue&type=script&lang=js&"
export * from "./InstantBuy.vue?vue&type=script&lang=js&"
import style0 from "./InstantBuy.vue?vue&type=style&index=0&id=ce0a9202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0a9202",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VIcon,VSheet,VSpacer,VToolbar,VToolbarTitle})
